export enum ProductLocations {
	Main = 'main', // -> detail
	Sticky = 'sticky', // -> detail -> sticky
	ColorSelector = 'color-selector', // -> detail -> color selector
	ColorSelectorSheet = 'color-selector-sheet', // -> detail -> color selector bottom sheet
	Grid = 'list', // -> plp, favorites?, search?
	Search = 'search_results',
	Carousel = 'product-carousel', // -> ??
	MangoStylist = 'mango-styling', // -> fashion assistant
	CrossSellingsPDP = 'pdp-cross-selling',
	CrossSellingSimilars = 'pdp-cross-selling:similars',
	CrossSellingTotalLook = 'pdp-cross-selling:total-look:main',
	CrossSellingPersonalization = 'pdp-cross-selling:recommended',
	CrossSellingShoppingCartPersonalization = 'bag:cross-selling:recommended',
	CrossSellingShoppingCartFavorites = 'bag:cross-selling:favorites',
	CrossSellingLastViewed = 'pdp-cross-selling:last-viewed',
	CrossSellingCollaborativeRecommendationsFavorite = 'favorite-cross-selling:collaborative',
	CrossSellingEmptyShoppingCartPersonalization = 'bag-empty:cross-selling:recommended',
	CrossSellingBestSeller = 'home-cross-selling:best-sellers',
	CrossSellingOurSelection = 'home-cross-selling:our-selection',
	CrossSellingFavoritesTotalLook = 'favorite-cross-selling:total-look',
	CrossSellingCollections = 'favorite-cross-selling:collections',
	ShopTheLook = 'pdp-cross-selling:total-look:shop-the-look',
	ShopTheLookSimilars = 'bag-cross-selling:similars',
	ShopTheLookBestSellers = 'bag-cross-selling:best-sellers',
	Edits = 'edits',
	SizeSelector = 'size-selector',
	QuantitySelector = 'quantity_selector',
	BagProductCard = 'product_card:remove',
}
